// extracted by mini-css-extract-plugin
export default {"Wrapper":"PipelineFolderDropDestination_Wrapper__lpwHb"};